import { useMemo } from "react";
import useGlobalStore from "src/stores/useGlobalStore";
import { isValidShareClipboardPayload } from "../share-variants/ShareClipboard";
import { isValidShareDownloadPayload } from "../share-variants/ShareDownload";
import { isValidShareIMessagePayload } from "../share-variants/ShareIMessage";
import { isValidShareInstagramDMPayload } from "../share-variants/ShareInstagramDM";
import { isValidShareInstagramStoryPayload } from "../share-variants/ShareInstagramStory";
import { isValidShareSharePayload } from "../share-variants/ShareShare";
import { SharePayload, ValidShareOption } from "../types";

const useValidShareOptions = (data: SharePayload[]): ValidShareOption[] => {
	const isSmsAvailable = useGlobalStore((state) => state.isSmsAvailable);
	const isIgAvailable = useGlobalStore((state) => state.isIgShareAvailable);

	const options = useMemo<ValidShareOption[]>(() => {
		const retOptions: ValidShareOption[] = [];

		if (isValidShareDownloadPayload(data)) {
			retOptions.push({
				key: "ShareDownload",
				data: data,
			} satisfies ValidShareOption);
		}
		if (isValidShareClipboardPayload(data)) {
			retOptions.push({
				key: "ShareClipboard",
				data: data,
			} satisfies ValidShareOption);
		}
		if (isValidShareSharePayload(data)) {
			retOptions.push({
				key: "ShareShare",
				data: data,
			} satisfies ValidShareOption);
		}
		if (
			isValidShareIMessagePayload(data, {
				isSmsAvailable,
			})
		) {
			retOptions.push({
				key: "ShareIMessage",
				data: data,
			} satisfies ValidShareOption);
		}
		if (isValidShareInstagramStoryPayload(data, { isIgAvailable })) {
			retOptions.push({
				key: "ShareInstagramStory",
				data: data,
			} satisfies ValidShareOption);
		}
		if (isValidShareInstagramDMPayload(data, { isIgAvailable })) {
			retOptions.push({
				key: "ShareInstagramDM",
				data: data,
			} satisfies ValidShareOption);
		}

		return retOptions;
	}, [data, isSmsAvailable, isIgAvailable]);

	return options;
};
export default useValidShareOptions;
